var _style, _circle, _g, _defs, _g2, _defs2, _g3, _defs3, _g4, _defs4, _g5, _defs5, _g6, _defs6, _g7, _defs7, _g8, _defs8, _g9, _defs9, _g10, _defs10, _g11, _defs11, _g12, _defs12, _g13, _defs13, _g14, _defs14, _g15, _defs15, _g16, _defs16, _g17, _defs17, _g18, _defs18, _g19, _defs19, _g20, _g21, _defs20, _g22, _defs21, _g23, _defs22, _g24, _defs23, _g25, _defs24, _g26, _defs25, _g27, _defs26, _g28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPyplot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:4.55;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st1{opacity:5.000000e-02;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t\r\n\t\t.st3{opacity:0.9;fill:none;stroke:#858585;stroke-width:0.41;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.41,0.81;enable-background:new    ;}\r\n\t.st4{clip-path:url(#SVGID_4_);}\r\n\t.st5{clip-path:url(#SVGID_6_);}\r\n\t.st6{clip-path:url(#SVGID_8_);}\r\n\t.st7{clip-path:url(#SVGID_10_);}\r\n\t.st8{clip-path:url(#SVGID_12_);}\r\n\t.st9{clip-path:url(#SVGID_14_);}\r\n\t.st10{clip-path:url(#SVGID_16_);}\r\n\t.st11{clip-path:url(#SVGID_18_);}\r\n\t\r\n\t\t.st12{opacity:0.9;fill:none;stroke:#818181;stroke-width:0.41;stroke-linecap:square;stroke-linejoin:round;stroke-dasharray:0.41,0.81;enable-background:new    ;}\r\n\t.st13{clip-path:url(#SVGID_20_);}\r\n\t.st14{clip-path:url(#SVGID_22_);}\r\n\t.st15{clip-path:url(#SVGID_24_);}\r\n\t.st16{opacity:0.94;}\r\n\t.st17{clip-path:url(#SVGID_26_);}\r\n\t.st18{opacity:0.6;fill:#004CFF;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st19{clip-path:url(#SVGID_28_);}\r\n\t.st20{opacity:0.6;fill:#CEFF29;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st21{clip-path:url(#SVGID_30_);}\r\n\t.st22{opacity:0.6;fill:#FF6800;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st23{clip-path:url(#SVGID_32_);}\r\n\t.st24{opacity:0.6;fill:#FFC400;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st25{clip-path:url(#SVGID_34_);}\r\n\t.st26{opacity:0.6;fill:#29FFCE;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st27{clip-path:url(#SVGID_36_);}\r\n\t.st28{opacity:0.6;fill:#7DFF7A;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st29{clip-path:url(#SVGID_38_);}\r\n\t.st30{fill:none;stroke:#11557C;stroke-width:1.99;stroke-linecap:square;stroke-miterlimit:10;}\r\n\t.st31{clip-path:url(#SVGID_40_);}\r\n\t.st32{opacity:0.6;fill:none;stroke:#000000;stroke-width:0.91;stroke-linejoin:round;enable-background:new    ;}\r\n\t.st33{clip-path:url(#SVGID_42_);}\r\n\t.st34{clip-path:url(#SVGID_44_);}\r\n\t.st35{clip-path:url(#SVGID_46_);}\r\n\t.st36{clip-path:url(#SVGID_48_);}\r\n\t.st37{clip-path:url(#SVGID_50_);}\r\n\t.st38{clip-path:url(#SVGID_52_);}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Matplotlib_tech"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4543"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path4395",
    className: "st0",
    cx: 65,
    cy: 45,
    r: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g4391"
  }, /*#__PURE__*/React.createElement("g", {
    id: "patch_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path329",
    className: "st1",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "matplotlib.axis_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "xtick_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path334",
    className: "st3",
    d: "M64.8,44.8h23.8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_2"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path338",
    className: "st3",
    d: "M64.8,44.8l16.7-16.7"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_3"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path342",
    className: "st3",
    d: "M64.8,44.8V21"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_4"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path346",
    className: "st3",
    d: "M64.8,44.8L48,28.2"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_5"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path350",
    className: "st3",
    d: "M64.8,44.8H41"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_6"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path354",
    className: "st3",
    d: "M64.8,44.8L48,61.6"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_7"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path358",
    className: "st3",
    d: "M64.8,44.8v23.8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "xtick_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_8"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path362",
    className: "st3",
    d: "M64.8,44.8l16.7,16.8"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "matplotlib.axis_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ytick_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_9"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path367",
    className: "st12",
    d: "M67.5,44.8v-0.6l-0.2-0.6l-0.5-0.5l-0.5-0.4l-0.6-0.3l-0.6-0.1h-0.6l-0.6,0.2l-0.5,0.3 l-0.5,0.4l-0.4,0.5l-0.2,0.6V45v0.6l0.3,0.6l0.4,0.5l0.5,0.4l0.6,0.3l0.6,0.1h0.6l0.6-0.2l0.5-0.3l0.5-0.5l0.3-0.5l0.2-0.6 V45l0,0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_10"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path371",
    className: "st12",
    d: "M72.7,44.8v-1.1l-0.2-1.1l-0.4-1l-0.6-0.9l-0.6-0.9l-0.8-0.8l-0.9-0.7l-1-0.6l-1-0.4 l-1.1-0.3h-1.1H64l-1.1,0.2l-1.1,0.3l-1,0.5L60,38.8l-0.8,0.7l-0.7,0.9l-0.6,0.9l-0.5,1l-0.3,1.1l-0.2,1.1v1.1l0.2,1.1 l0.3,1.1l0.5,1l0.6,0.9l0.7,0.9l0.8,0.7l0.9,0.6l1,0.5l1.1,0.4l1.1,0.2h1.1l1.1-0.1l1.1-0.3l1-0.4l1-0.5l0.9-0.7l0.8-0.8 l0.6-0.9l0.5-1l0.4-1l0.2-1.1V45l0,0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_11"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path375",
    className: "st12",
    d: "M78,44.8v-1.4l-0.2-1.4l-0.3-1.3L77,39.5l-0.6-1.2l-0.8-1.1l-1-1.1l-1-1l-1.1-0.9 l-1.2-0.8l-1.2-0.6l-1.3-0.5l-1.3-0.4l-1.4-0.2h-1.4h-1.4l-1.4,0.2l-1.3,0.4l-1.3,0.5l-1.2,0.6l-1.2,0.8L56.1,35l-1,1 l-0.9,1.1l-0.8,1.1l-0.6,1.2l-0.5,1.3l-0.4,1.3l-0.2,1.4v1.4v1.4l0.2,1.4l0.4,1.3l0.5,1.3l0.6,1.2l0.8,1.2l0.9,1.1l1,1 l1.1,0.9l1.2,0.8l1.2,0.6l1.4,0.6l1.3,0.4l1.4,0.2h1.4h1.4l1.4-0.2l1.3-0.4l1.3-0.5l1.2-0.6l1.2-0.8l1.1-0.9l1-1l0.9-1.1 l0.8-1.2l0.6-1.2l0.5-1.3l0.4-1.3l0.2-1.4L78,44.8L78,44.8"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "ytick_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line2d_12"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path379",
    className: "st12",
    d: "M83.3,44.8v-1.9L83,41l-0.5-1.9l-0.7-1.8l-0.9-1.7l-1-1.6l-1.2-1.5l-1.5-1.2L75.7,30 l-1.6-1.2L72.3,28l-1.8-0.7l-1.9-0.5l-1.9-0.3h-1.9h-1.9L61,26.8l-1.9,0.5L57.3,28l-1.7,0.9l-1.6,1l-1.5,1.3l-1.4,1.4 l-1.2,1.5l-1,1.5l-0.9,1.7l-0.7,1.8L46.9,41l-0.3,1.9v1.9v1.9l0.3,1.9l0.5,1.9l0.7,1.8l0.9,1.7l1.1,1.6l1.2,1.5l1.4,1.4 l1.5,1.2l1.6,1l1.7,0.9l1.8,0.7l1.9,0.5l1.9,0.3h1.9h1.9l1.9-0.3l1.9-0.5l1.8-0.7l1.7-0.9l1.6-1l1.5-1.2l1.4-1.4l1.2-1.5 l1.1-1.6l0.9-1.7l0.7-1.8l0.5-1.9l0.3-1.9V44.8L83.3,44.8"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_3",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_25_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path382",
    className: "st18",
    d: "M64.8,44.8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_4",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_27_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path385",
    className: "st20",
    d: "M64.8,44.8L64.8,44.8v-0.1v-0.1v-0.2v-0.1v-0.1V44v-0.1v-0.2v-0.1v-0.1v-0.1l0.8-0.1V43 v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V42v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V40v-0.1v-0.2v-0.1v-0.1 v-0.1v-0.2V39v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V38v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V36v-0.1v-0.2 v-0.1v-0.1v-0.1v-0.2V35v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V34v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V32 v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2V31v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1H73l0,0h0.3l0,0h0.3l0,0h0.2l0,0h0.2l0,0h0.2l0,0l0,0l0,0 h0.1l0,0l0,0v0.1l0,0l0,0l0,0l0,0v0.1l0,0l0,0v0.1l0,0v0.1v0.1l0,0l-0.1,0.1l0,0V31v0.1l0,0v0.1v0.1v0.1v0.1v0.1l0,0v0.1V32 v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1v0.1l0,0V33l0,0v0.1v0.1l0,0v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1 v0.1l0,0v0.1v0.1l0,0V35l0,0v0.1v0.1l0,0v0.1v0.1H74v0.1l0,0v0.1v0.1l0,0V36v0.1v0.1v0.1l0,0v0.1v0.1v0.1l-0.1,0.1V37l0,0 v0.1v0.1v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0V38v0.1l0,0v0.1L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_5",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_29_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path388",
    className: "st22",
    d: "M64.8,44.8L64.8,44.8l-0.1-0.2l-0.1-0.1l-0.1-0.2l-0.1-0.2V44l-0.1-0.2L64,43.7v-0.2 l-0.1-0.2l-0.4-0.2V43l-0.3-0.1l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.2l-0.1-0.1v-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2L62,41.1 L61.8,41l-0.4-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.3-0.1V40l-0.1-0.2l-0.1-0.2v-0.1l-0.1-0.2l-0.1-0.2V39l-0.1-0.2L60,38.7 l-0.1-0.2v-0.2l-0.1-0.2L59.5,38l-0.1-0.1l-0.1-0.2l-0.1-0.2L59,37.4l-0.6-0.2v-0.1v-0.2l-0.1-0.2l-0.1-0.2v-0.2L58,36.3 L57.5,36v-0.2l-0.3-0.1l-0.1-0.2v-0.1L57,35.3l-0.1-0.2V35l-0.1-0.2l-0.1-0.1l-0.5-0.2v-0.2l-0.1-0.2L55.8,34l-0.1-0.1 l-0.2-0.2h-0.1v-0.2l-0.1-0.2l-0.1-0.1V33l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.1-0.2V32l-0.1-0.2l-0.7-0.3v-0.1l-0.2-0.2 l-0.1-0.2v-0.2l-0.1-0.2L53,30.6l-0.1-0.1l-0.1-0.2l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.1-0.2v-0.2l-0.1-0.2l-0.5-0.3v-0.1 l-0.3-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.2l0,0h0.2l0,0h6.8l0,0h0.5l0,0h1v0.2V29v0.2 v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V33v0.2v0.2v0.2v0.2V34v0.2v0.2v0.2v0.2V35v0.2v0.2 v0.2v0.2V36v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V40v0.2v0.2v0.2v0.2V41v0.2v0.2v0.2 v0.2V42v0.2v0.2v0.2v0.2V43v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V47v0.2v0.2v0.2v0.2V48 v0.2v0.2v0.2v0.2V49L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_6",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path391",
    className: "st24",
    d: "M64.8,44.8L64.8,44.8h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2 h-0.4h-0.2H61l-0.2,0.7h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2H59h-0.2h-0.2h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4H57h-0.4h-0.2h-0.2h-0.2 h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2H53h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2H51h-0.2h-0.2h-0.2 h-0.4h-0.2h-0.4h-0.2h-0.2H49h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.4H47h-0.2h-0.2v-5.3l0,0V40l0,0v-0.2v-0.1l0,0v-0.1l0,0v-0.1 v-0.5l0,0v-0.1l0,0v-0.1l0,0l0,0l0,0l0,0v-0.1l0,0v-0.1l0,0v-0.1l0,0v-0.1l0,0l0,0l0,0l0,0h0.2H47h0.2h0.2h0.2h0.2h0.2H48 h0.2h0.2h0.2h0.2h0.2H49h0.2h0.2h0.2l1.8,0.2l0,0h0.2h0.2h0.2H52h0.2h0.2h0.2h0.2h0.2H53h0.2h0.2h0.2h0.2h0.2H54h0.2h0.2h0.2 h0.2h0.2H55h0.2h0.2h0.2h0.2h0.2H56h0.2h0.2h0.2h0.2h0.2H57h0.2h0.2h0.2h0.2h0.2H58h0.2h0.2h0.1h0.2h0.2H59h0.2h0.2h0.2h0.2 h0.2H60h0.2h0.2h0.2h0.2h0.2H61h0.2h0.2h0.2h0.2h0.2H62h0.2h0.2h0.2h0.2h0.2H63h0.2h0.2h0.2h0.2h0.2H64h0.2h0.2h0.2h0.2 L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_7"
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path394",
    className: "st26",
    d: "M64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8H64l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0H64.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_8",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_35_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path397",
    className: "st28",
    d: "M64.8,44.8L64.8,44.8v13h-2.9v-0.4v-0.1v-0.4v-0.1v-0.4v-0.1v-0.5v-0.1V55v-0.1v-0.4v-0.1 v-0.5v-0.1v-0.4l0,0V53v-0.1v-0.5v-0.1v-0.4v-0.1v-0.4v-0.1v-0.5v-0.1v-0.4V50v-0.4v-0.1v-0.4V49v-0.5v-0.1v-0.5v-0.1v-0.4 l0,0v-0.5l0,0v-0.4v-0.1V46v-0.1v-0.5v-0.1L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_9",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_37_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path400",
    className: "st22",
    d: "M64.8,44.8L64.8,44.8L65,45l0.2,0.1h0.2l0.2,0.1l0.1,0.3l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1 l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.1,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1-0.2l-0.1-0.2v-0.2l-3.6,5.1v-0.2l-0.1-0.2 l-0.1-0.1L77.1,60l-0.3-0.2h-0.1l-0.1-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2L76,59l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2l-0.5-0.3 v-0.2L75,57.5l-0.1-0.1l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2L74,55.6v-0.2l-0.1-0.2v-0.2 L73.7,55v-0.2l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.2V54l-0.1-0.2v-0.2L73,53.5v-0.1l-0.1-0.2V53l-1.7-0.3v-0.2L71,52.3v-0.2 L70.9,52v-0.2l-0.5-0.1v-0.2l-0.1-0.2l-0.1-0.2v-0.2L69.9,51v-0.2l-0.1-0.2v-0.2l-0.6-0.2v-0.2L69,50v-0.2l-0.1-0.2v-0.2 l-0.1-0.2v-0.2L68.6,49v-0.2L68,48.6v-0.2l-0.1-0.2l-0.1-0.2V48l-0.5-0.1v-0.2L67,47.6v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2 l-0.1-0.2v-0.1l-0.1-0.2l-0.1-0.2l-0.8-0.3v-0.2l-0.2-0.1l-0.1-0.2l-0.1-0.2L65,45L64.8,44.8z"
  }))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "patch_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path403",
    className: "st30",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "patch_3-1"
  }, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path382-9",
    className: "st32",
    d: "M64.8,44.8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_4-2"
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_41_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path385-8",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8v-0.1v-0.1v-0.2v-0.1v-0.1V44v-0.1v-0.2v-0.1v-0.1v-0.1l0.8-0.1V43 v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V42v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V40v-0.1v-0.2v-0.1v-0.1 v-0.1v-0.2V39v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V38v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V36v-0.1v-0.2 v-0.1v-0.1v-0.1v-0.2V35v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V34v-0.2v-0.1v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1V32 v-0.1v-0.2v-0.1v-0.1v-0.1v-0.2V31v-0.1v-0.1v-0.1v-0.2v-0.1v-0.1H73l0,0h0.3l0,0h0.3l0,0h0.2l0,0h0.2l0,0h0.2l0,0l0,0l0,0 h0.1l0,0l0,0v0.1l0,0l0,0l0,0l0,0v0.1l0,0l0,0v0.1l0,0v0.1v0.1l0,0l-0.1,0.1l0,0V31v0.1l0,0v0.1v0.1v0.1v0.1v0.1l0,0v0.1V32 v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1v0.1l0,0V33l0,0v0.1v0.1l0,0v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1v0.1l0,0v0.1l0,0v0.1 v0.1l0,0v0.1v0.1l0,0V35l0,0v0.1v0.1l0,0v0.1v0.1H74v0.1l0,0v0.1v0.1l0,0V36v0.1v0.1v0.1l0,0v0.1v0.1v0.1l-0.1,0.1V37l0,0 v0.1v0.1v0.1v0.1l0,0v0.1v0.1l0,0v0.1l0,0V38v0.1l0,0v0.1L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_5-0"
  }, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_43_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path388-3",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8l-0.1-0.2l-0.1-0.1l-0.1-0.2l-0.1-0.2V44l-0.1-0.2L64,43.7v-0.2 l-0.1-0.2l-0.4-0.2V43l-0.3-0.1l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.2l-0.1-0.1v-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2L62,41.1 L61.8,41l-0.4-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.3-0.1V40l-0.1-0.2l-0.1-0.2v-0.1l-0.1-0.2l-0.1-0.2V39l-0.1-0.2L60,38.7 l-0.1-0.2v-0.2l-0.1-0.2L59.5,38l-0.1-0.1l-0.1-0.2l-0.1-0.2L59,37.4l-0.6-0.2v-0.1v-0.2l-0.1-0.2l-0.1-0.2v-0.2L58,36.3 L57.5,36v-0.2l-0.3-0.1l-0.1-0.2v-0.1L57,35.3l-0.1-0.2V35l-0.1-0.2l-0.1-0.1l-0.5-0.2v-0.2l-0.1-0.2L55.8,34l-0.1-0.1 l-0.2-0.2h-0.1v-0.2l-0.1-0.2l-0.1-0.1V33l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.1-0.2V32l-0.1-0.2l-0.7-0.3v-0.1l-0.2-0.2 l-0.1-0.2v-0.2l-0.1-0.2L53,30.6l-0.1-0.1l-0.1-0.2l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.1l-0.1-0.2v-0.2l-0.1-0.2l-0.5-0.3v-0.1 l-0.3-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0h0.2l0,0h0.2l0,0h6.8l0,0h0.5l0,0h1v0.2V29v0.2 v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V33v0.2v0.2v0.2v0.2V34v0.2v0.2v0.2v0.2V35v0.2v0.2 v0.2v0.2V36v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V40v0.2v0.2v0.2v0.2V41v0.2v0.2v0.2 v0.2V42v0.2v0.2v0.2v0.2V43v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2v0.2V47v0.2v0.2v0.2v0.2V48 v0.2v0.2v0.2v0.2V49L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_6-4"
  }, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_45_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path391-5",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4 h-0.2h-0.4h-0.2H61l-0.2,0.7h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2H59h-0.2h-0.2h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4H57h-0.4h-0.2h-0.2 h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2H53h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2h-0.2H51h-0.2h-0.2 h-0.2h-0.4h-0.2h-0.4h-0.2h-0.2H49h-0.4h-0.2h-0.2h-0.2h-0.4h-0.2h-0.4H47h-0.2h-0.2v-5.3l0,0V40l0,0v-0.2v-0.1l0,0v-0.1l0,0 v-0.1v-0.5l0,0v-0.1l0,0v-0.1l0,0l0,0l0,0l0,0v-0.1l0,0v-0.1l0,0v-0.1l0,0v-0.1l0,0l0,0l0,0l0,0h0.2H47h0.2h0.2h0.2h0.2h0.2 H48h0.2h0.2h0.2h0.2h0.2H49h0.2h0.2h0.2l1.8,0.2l0,0h0.2h0.2h0.2H52h0.2h0.2h0.2h0.2h0.2H53h0.2h0.2h0.2h0.2h0.2H54h0.2h0.2 h0.2h0.2h0.2H55h0.2h0.2h0.2h0.2h0.2H56h0.2h0.2h0.2h0.2h0.2H57h0.2h0.2h0.2h0.2h0.2H58h0.2h0.2h0.1h0.2h0.2H59h0.2h0.2h0.2 h0.2h0.2H60h0.2h0.2h0.2h0.2h0.2H61h0.2h0.2h0.2h0.2h0.2H62h0.2h0.2h0.2h0.2h0.2H63h0.2h0.2h0.2h0.2h0.2H64h0.2h0.2h0.2h0.2 L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_7-2",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_47_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path394-8",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8 L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8L64.8,44.8H64l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0H64.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_8-8"
  }, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_49_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_50_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path397-2",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8v13h-2.9v-0.4v-0.1v-0.4v-0.1v-0.4v-0.1v-0.5v-0.1V55v-0.1v-0.4 v-0.1v-0.5v-0.1v-0.4l0,0V53v-0.1v-0.5v-0.1v-0.4v-0.1v-0.4v-0.1v-0.5v-0.1v-0.4V50v-0.4v-0.1v-0.4V49v-0.5v-0.1v-0.5v-0.1 v-0.4l0,0v-0.5l0,0v-0.4v-0.1V46v-0.1v-0.5v-0.1L64.8,44.8z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "patch_9-9"
  }, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_51_",
    d: "M64.8,68.6c13.1,0,23.8-10.6,23.8-23.8S78,21,64.9,21c-13.1,0-23.8,10.6-23.8,23.8 c0,6.3,2.5,12.4,7,16.9C52.5,66.1,58.5,68.6,64.8,68.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_52_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path400-2",
    className: "st32",
    d: "M64.8,44.8L64.8,44.8L65,45l0.2,0.1h0.2l0.2,0.1l0.1,0.3l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1 l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.1,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1h0.2 l0.2,0.1l0.2,0.1h0.2l0.2,0.1h0.2l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0.2,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0 l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l-0.1-0.2l-0.1-0.2v-0.2l-3.6,5.1v-0.2l-0.1-0.2 l-0.1-0.1L77.1,60l-0.3-0.2h-0.1l-0.1-0.2l-0.1-0.2l-0.1-0.2l-0.1-0.2L76,59l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2l-0.5-0.3 v-0.2L75,57.5l-0.1-0.1l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2L74,55.6v-0.2l-0.1-0.2v-0.2 L73.7,55v-0.2l-0.1-0.2l-0.1-0.2v-0.2l-0.1-0.2V54l-0.1-0.2v-0.2L73,53.5v-0.1l-0.1-0.2V53l-1.7-0.3v-0.2L71,52.3v-0.2 L70.9,52v-0.2l-0.5-0.1v-0.2l-0.1-0.2l-0.1-0.2v-0.2L69.9,51v-0.2l-0.1-0.2v-0.2l-0.6-0.2v-0.2L69,50v-0.2l-0.1-0.2v-0.2 l-0.1-0.2v-0.2L68.6,49v-0.2L68,48.6v-0.2l-0.1-0.2l-0.1-0.2V48l-0.5-0.1v-0.2L67,47.6v-0.2l-0.1-0.2v-0.2l-0.1-0.2v-0.2 l-0.1-0.2v-0.1l-0.1-0.2l-0.1-0.2l-0.8-0.3v-0.2l-0.2-0.1l-0.1-0.2l-0.1-0.2L65,45L64.8,44.8z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyplot);
export default __webpack_public_path__ + "static/media/Pyplot.2159dd5f145caee4d34c05f9dbc45c00.svg";
export { ForwardRef as ReactComponent };